import NoMatchPage from "app/404Page";
import GetStartedPage from "pages/GetStarted";
import { selectUserProfile } from "pages/User";
import { useSelector } from "react-redux";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";

export const AllRoutes = () => {
  const user = useSelector(selectUserProfile);
  return (
    <Router>
      <Routes>
        {PublicRoutes()}
        {PrivateRoutes()}

        {/* Public route */}
        <Route path="/get-started" element={<GetStartedPage />} />

        {/* Conditional route handling */}
        {/* {user?.uid ? (
          // Private route
          <Route path="/get-started" element={<GetStartedPage />} />
        ) : (
          // Redirect to public page if not authenticated
          <Route path="/get-started" element={<Navigate to="/get-started" replace />} />
        )} */}
        <Route path="/" element={<Navigate to={user ? "/" : "/register"} replace />} />
        <Route path="*" element={<NoMatchPage />} />
      </Routes>
    </Router>
  );
};
